import Routes from "@/common/router/Routes";
import FacilityRouter from "@/context/facility/router/FacilityRouter";

export default class FacilityRoutes extends Routes {
  constructor() {
    super({
      label: "Obiekt",
      router: new FacilityRouter(),
      lazyPage: () => import("@/context/facility/pages/FacilityPage.vue"),
      lazyCreate: () => import("@/context/facility/containers/FacilityFormContainer.vue"),
      lazyUpdate: () => import("@/context/facility/containers/FacilityFormContainer.vue"),
      lazyList: () => import("@/context/facility/containers/FacilityListContainer.vue"),
      lazyShow: () => import("@/context/facility/containers/FacilityShowContainer.vue")
    });
  }
}

export const facilityRoutes = new FacilityRoutes();
